import { Outlet } from 'react-router-dom';
import { TabNav } from '@/components/tab-nav';

const TABS = [
  { to: '/account', label: 'Profile', end: true },
  { to: '/account/security', label: 'Sign-in & security' },
  { to: '/account/appearance', label: 'Appearance' },
];

/** Account settings, one topic per tab. */
export function AccountLayout() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Account</h1>
        <TabNav className="mt-4" tabs={TABS} />
      </div>
      {/* Settings forms keep the standard form width. */}
      <div className="max-w-3xl space-y-6">
        <Outlet />
      </div>
    </div>
  );
}
